import {
    APPTOOLBAR_RESET_APP_STATE,
    CLOSE_MANIFOLD_ENTRY,
    CLOSE_MANIFOLD_REMOVAL_PROMPT_DIALOG,
    DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE,
    GLOBAL_DRAWING_SELECTOR_MODE_DIRECT,
    MANIFOLD_ENTRY_CHECK_FOR_OVERLAP,
    MANIFOLD_ENTRY_MOVED,
    MANIFOLD_ENTRY_SHOW_OVERLAP_DIALOG,
    MANIFOLD_ENTRY_REMOVE_OVERLAPPING,
    SET_CURRENT_MANIFOLD_ENTRY,
    SET_OVERLAP_PRESENT,
    SET_SELECTED_MANIFOLD,
    SHOW_MANIFOLD_ENTRY,
    SWITCH_PRODUCT_TYPE,
    SET_STRUCTURE_COLLISION_PRESENT,
    SET_OP_STRUCTURE_COLLISION_PRESENT,
    MANIFOLD_ENTRY_MANIFOLD_CHAMBER_SHOW_EDIT_OR_REMOVE_PROMPT,
} from "../lib/types";

const initialState = {
    x: 0,
    y: 0,
    manifoldId: null,
    accessory: null,
    showManifoldEntryDialog: false,
    checkForOverlap: false,
    showOverlapDialog: false,
    overlappedManifold: null, // the manifold under
    overlappingManifold: null, // the manifold over
    promptForRemoval: false,
    overlapPresent: false,
    showCurrentManifold: true,
    currentManifold: null, // current manifold
    structureCollisionDetected: false,
    oppositeStructureCollisionDetected: false,
    oppositeManifoldsIds: [],
    showManifoldChamberEditOrRemovePrompt: false,
    manifoldChamberEditOrRemoveData: {
        manifoldId: null,
        accessory: null,
        row: null,
        col: null
    }
};

export const ManifoldEntryReducer = (state = initialState, action) => {
    switch (action.type) {
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        case MANIFOLD_ENTRY_MOVED:
            return {
                ...state,
                x: action.payload.x,
                y: action.payload.y,
            };

        case CLOSE_MANIFOLD_ENTRY:
            return {
                ...state,
                showManifoldEntryDialog: false,
                manifoldId: null,
                accessory: null
            };

        case SET_CURRENT_MANIFOLD_ENTRY:
            return {
                ...state,
                currentManifold: action.payload.currentManifold
            };

        case SHOW_MANIFOLD_ENTRY:
            return {
                ...state,
                showManifoldEntryDialog: true,
                accessory: action.payload.accessory,
                manifoldId: action.payload.manifoldId,
                checkForOverlap: !!(action.payload.checkForOverlap),
                promptForRemoval: action.payload.promptForRemoval,
            };

        case SET_SELECTED_MANIFOLD:
            return {
                ...state,
                accessory: { ...action.payload.accessory },
                manifoldId: action.payload.manifoldId
            };

        case DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE:
            if (action.payload === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT)
                return {
                    ...state,
                    showManifoldEntryDialog: false,
                    accessory: null,
                    manifoldId: null
                };
            else
                return state;

        case MANIFOLD_ENTRY_CHECK_FOR_OVERLAP:
            return {
                ...state,
                checkForOverlap: action.payload,
                showOverlapDialog: false,
                overlappedManifold: null,
            };

        case MANIFOLD_ENTRY_SHOW_OVERLAP_DIALOG:
            return {
                ...state,
                showOverlapDialog: action.payload.showOverlapDialog,
                overlappedManifold: action.payload.overlappedManifold,
                overlappingManifold: action.payload.overlappingManifold,
                checkForOverlap: false,
            };

        case MANIFOLD_ENTRY_REMOVE_OVERLAPPING:
            return {
                ...state,
                overlappingManifold: null,
                overlappedManifold: null,
                overlapPresent: false,
            };

        case SWITCH_PRODUCT_TYPE:
            if (action.payload === "PIPE")
                return initialState;
            else
                return state;

        case CLOSE_MANIFOLD_REMOVAL_PROMPT_DIALOG:
            return {
                ...state,
                promptForRemoval: false,
            };

        case SET_OVERLAP_PRESENT:
            return {
                ...state,
                overlapPresent: action.payload,
            };

        case SET_STRUCTURE_COLLISION_PRESENT:
            return {
                ...state,
                structureCollisionDetected: action.payload,
            };

        case SET_OP_STRUCTURE_COLLISION_PRESENT:
            return {
                ...state,
                oppositeStructureCollisionDetected: action.payload.detected,
                oppositeManifoldsIds: action.payload.manifoldsIds
            };
        case MANIFOLD_ENTRY_MANIFOLD_CHAMBER_SHOW_EDIT_OR_REMOVE_PROMPT:
            return action.payload.show
                ? {
                    ...state,
                    showManifoldChamberEditOrRemovePrompt: true,
                    manifoldChamberEditOrRemoveData: {
                        manifoldId: action.payload.manifoldId,
                        accessory: action.payload.accessory,
                        row: action.payload.row,
                        col: action.payload.col
                    }
                } : {
                    ...state,
                    showManifoldChamberEditOrRemovePrompt: false,
                    manifoldChamberEditOrRemoveData: initialState.manifoldChamberEditOrRemoveData
                };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/manifold-entry-reducer.js